export default __webpack_public_path__ + "static/media/Saurashtre-Somnatham.a31bf3df.mp3";